import * as React from 'react';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AddressForm from './AddressForm';
import PaymentForm from './PaymentForm';
import Review from './Review';
import { useElements, useStripe } from '@stripe/react-stripe-js';
import { SessionContext } from '../../context/Session';
import PageHeader from '../../components/PageHeader';
import * as emailjs from 'emailjs-com';
import { useHistory } from 'react-router';

export default function Checkout() {
  const history = useHistory();
  const elements = useElements();
  const stripe = useStripe();

  const { purchaseItem, setPurchaseItem, shipping } =
    React.useContext(SessionContext);

  const [isProcessing, setProcessingTo] = React.useState(false);
  const [paymentSuccessful, setPaymentSuccessful] = React.useState(false);
  const [order, setOrder] = React.useState();
  const [checkoutError, setCheckoutError] = React.useState();
  const [total, setTotal] = React.useState(0);
  const [tax, setTax] = React.useState(0);
  const [customOrderId, setCustomOrderId] = React.useState();

  React.useEffect(() => {
    console.log(history);
    if (history.location.pathname.includes('custom')) {
      getCustomOrder();
    } else {
      getTotal();
    }
  }, []);

  const getCustomOrder = () => {
    setCustomOrderId(history.location.pathname.split('custom/')[1]);
    fetch(
      `https://sheline-art-website-api.herokuapp.com/custom-orders/item/${
        history.location.pathname.split('custom/')[1]
      }`
    )
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          if (result.paid) {
            history.push(`/custom-order/status/${result.id}`);
          }
          setPurchaseItem(result);
          console.log(result);
          getTotal(result);
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const getShipping = () => {
    if (!shipping) return true;
    if (
      shipping.firstName ||
      shipping.lastName ||
      shipping.addressLine1 ||
      shipping.city ||
      shipping.state ||
      shipping.zipCode ||
      shipping.email
    ) {
      return false;
    } else {
      return true;
    }
  };

  const handleFormSubmit = async (ev) => {
    ev.preventDefault();

    const billingDetails = {
      name: shipping.firstName + ' ' + shipping.lastName,
      email: shipping.email,
      address: {
        city: shipping.city,
        line1: shipping.addressLine1,
        state: shipping.state,
        postal_code: shipping.zipCode,
      },
    };
    setProcessingTo(true);
    setCheckoutError();

    const cardElement = elements.getElement('card');
    try {
      const url = `https://sheline-art-website-api.herokuapp.com/shop/secret`;
      // const url = `http://localhost:3001/shop/secret`;
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          amount: total * 100,
        }),
      };
      const response = await fetch(url, requestOptions);
      const clientSecret = await response.json();
      const paymentMethodReq = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
        billing_details: billingDetails,
      });

      if (paymentMethodReq.error) {
        console.log('errrrrror', paymentMethodReq.error.message);
        setCheckoutError(paymentMethodReq.error.message);
        setProcessingTo(false);
        return;
      }

      const { error } = await stripe.confirmCardPayment(clientSecret, {
        payment_method: paymentMethodReq.paymentMethod.id,
      });

      if (error) {
        console.log(error);
        console.log(error.message);
        setCheckoutError(error.message);
        setProcessingTo(false);
        return;
      }
      const orderURL = `https://sheline-art-website-api.herokuapp.com/orders`;
      // const orderURL = `http://localhost:3001/orders`;
      const orderReqOpts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          item_id: purchaseItem.id,
          name: shipping.firstName + ' ' + shipping.lastName,
          address_line_1: shipping.addressLine1,
          city: shipping.city,
          state: shipping.state,
          total,
          zip_code: shipping.zipCode,
          email: shipping.email,
          shipping: purchaseItem.shipping,
          price: purchaseItem.price,
          tax: tax,
          custom_order_id: customOrderId,
          phone_number: shipping.phoneNumber,
        }),
      };
      const orderResponse = await fetch(orderURL, orderReqOpts);
      const orderInfo = await orderResponse.json();
      setOrder(orderInfo);
      const templateParams = {
        name: orderInfo.name,
        email: orderInfo.email,
        price: orderInfo.price,
        shipping: orderInfo.shipping,
        total: orderInfo.total,
        orderId: orderInfo.id,
        custom_order_id: customOrderId,
      };
      if (customOrderId) {
        emailjs.send(
          'service_aqwqfqf',
          'template_7pi01hk',
          templateParams,
          'user_eA4SwTxRO6tlvA4TufCPY'
        );
      } else {
        emailjs.send(
          'service_aqwqfqf',
          'template_vhdaego',
          templateParams,
          'user_eA4SwTxRO6tlvA4TufCPY'
        );
      }
      setPaymentSuccessful(true);
      setProcessingTo(false);
    } catch (err) {
      setCheckoutError(err.message);
      setProcessingTo(false);
    }
  };
  const getTotal = (customOrder) => {
    const { price, shipping } = purchaseItem || customOrder;
    const tax = price * 0.0825;
    setTax(tax);
    const total = shipping
      ? tax + parseInt(price) + parseInt(shipping)
      : tax + parseInt(price);
    setTotal(total);
  };

  const pageHeader = {
    title: `Receipt`,
    description:
      "Multiple lines of text that form the lede, informing new readers quickly and efficiently about what's most interesting in this post's contents.",
    image: 'https://source.unsplash.com/random',
    imageText: 'main image description',
  };
  return (
    <Container component='main' maxWidth='md' sx={{ mb: 4 }}>
      <Paper
        variant='outlined'
        sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}
      >
        {!paymentSuccessful && (
          <Typography
            component='h1'
            variant='primary'
            sx={{ mt: 5, fontSize: 50 }}
            align='center'
          >
            Checkout
          </Typography>
        )}
        {checkoutError && (
          <Typography component='h1' variant='h6' align='center' color='error'>
            {checkoutError}
          </Typography>
        )}
        {paymentSuccessful ? (
          <React.Fragment>
            <PageHeader post={pageHeader} />
            <Typography variant='primary' gutterBottom>
              Thank you for your order, {order.name}.
            </Typography>
            <Typography variant='subtitle1'>
              Your order number is #{order.id}. We have emailed your order
              confirmation, and will send you an update when your order has
              shipped.
            </Typography>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {purchaseItem && (
              <Review total={total.toFixed(2)} tax={tax.toFixed(2)} />
            )}
            <AddressForm />
            <PaymentForm />
            <Button
              disabled={isProcessing || !stripe || getShipping()}
              variant='contained'
              onClick={handleFormSubmit}
              sx={{ mt: 5, fontSize: 25 }}
              fullWidth
            >
              {isProcessing ? 'Processing...' : `Pay $${total.toFixed(2)}`}
            </Button>
          </React.Fragment>
        )}
      </Paper>
    </Container>
  );
}
